import { useState } from 'react';
import { useDataFetchingClient } from 'data-fetching-client';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import FetchObjectHeader from 'automation-ui-formula-editor/fetch-object-panel/components/FetchObjectHeader';
import SelectDataSource from 'automation-ui-formula-editor/fetch-object-panel/containers/SelectDataSource';
import { DisplayMode } from 'automation-ui-formula-editor/fetch-object-panel/types/fetchObjectPanelTypes';
import { ADD_DATA_SOURCE_PANEL_CLASS_NAME } from 'automation-ui-formula-editor/data-passing-panel/utils/isClickEventFrom';
import { PANEL_STANDARD_WIDTH } from 'automation-ui-formula-editor/fetch-object-panel/constants/fetchObjectPanelConstants';
import { FETCHED_OBJECTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME, GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME } from 'automation-ui-formula-editor/data-sources/queries/getPrefixQueries';
import AddDataSource from 'automation-ui-formula-editor/fetch-object-panel/containers/AddDataSource';
import EditDataSource from 'automation-ui-formula-editor/fetch-object-panel/containers/EditDataSource';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FetchObjectPanel = ({
  onClose,
  flowId,
  flowObjectTypeId,
  fetchObjectCreatedCallback,
  fetchObjectDeletedCallback,
  initialDisplayMode = DisplayMode.SELECT,
  isFlowEnabled = false,
  objectTypeFilter
}) => {
  const [panelDisplayMode, setPanelDisplayMode] = useState(initialDisplayMode);
  const [dataSourceToEdit, setDataSourceToEdit] = useState();
  const dataFetchingClient = useDataFetchingClient();
  const onCloseAndScrollToDataSource = ({
    addedDataSourceName
  }) => {
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      args: {
        flowId,
        flowObjectTypeId,
        prefix: FETCHED_OBJECTS,
        query: {}
      }
    });
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME
    });
    if (fetchObjectCreatedCallback) {
      fetchObjectCreatedCallback(addedDataSourceName);
    }
    onClose();
  };
  const onDataSourceDelete = ({
    deletedDataSourceName
  }) => {
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      args: {
        flowId,
        flowObjectTypeId,
        prefix: FETCHED_OBJECTS,
        query: {}
      }
    });
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME
    });
    if (fetchObjectDeletedCallback) {
      fetchObjectDeletedCallback(deletedDataSourceName);
    }
  };
  let panelContent = null;
  if (panelDisplayMode === DisplayMode.ADD) {
    panelContent = /*#__PURE__*/_jsx(AddDataSource, {
      onClose: onClose,
      onCloseAndScrollToDataSource: onCloseAndScrollToDataSource,
      flowObjectTypeId: flowObjectTypeId,
      objectTypeFilter: objectTypeFilter
    });
  } else if (panelDisplayMode === DisplayMode.EDIT && dataSourceToEdit) {
    panelContent = /*#__PURE__*/_jsx(EditDataSource, {
      onClose: () => {
        setDataSourceToEdit(undefined);
        setPanelDisplayMode(DisplayMode.SELECT);
      },
      objectTypeFilter: objectTypeFilter,
      dataSourceToEdit: dataSourceToEdit
    });
  } else {
    panelContent = /*#__PURE__*/_jsx(SelectDataSource, {
      onDataSourceDelete: onDataSourceDelete,
      onDataSourceEdit: dataSource => {
        setDataSourceToEdit(dataSource);
        setPanelDisplayMode(DisplayMode.EDIT);
      },
      onClickAddDataSource: () => {
        setPanelDisplayMode(DisplayMode.ADD);
      },
      isFlowEnabled: isFlowEnabled
    });
  }

  // DEV NOTE: The className of this UIModalPanel (addDataSourcePanel) is used for onFocus/onBlur
  // detection in the DataPassingContext. Do not remove. @pmerlino 12/7/22
  return /*#__PURE__*/_jsx("div", {
    className: ADD_DATA_SOURCE_PANEL_CLASS_NAME,
    children: /*#__PURE__*/_jsxs(UIModalPanel, {
      width: PANEL_STANDARD_WIDTH,
      onEsc: onClose,
      children: [/*#__PURE__*/_jsx(FetchObjectHeader, {
        onBack: panelDisplayMode !== DisplayMode.SELECT ? () => {
          setDataSourceToEdit(undefined);
          setPanelDisplayMode(DisplayMode.SELECT);
        } : undefined,
        onClose: onClose,
        panelDisplayMode: panelDisplayMode
      }), panelContent]
    })
  });
};
export default FetchObjectPanel;